import React from "react";
import PropTypes from "prop-types";
import { Div } from "glamorous";
import { keyframes } from "glamor";
import mediaQueries from "../../styles/media-queries";

const spinnerAnim = keyframes({
  to: { transform: "rotate(360deg)" }
});

const styles = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  alignContent: "center",
  width: "100%",
  "& span": {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    border: "1px solid #ccc",
    borderTopColor: "#07d",
    animation: `${spinnerAnim} .6s linear infinite`,
    marginTop: "0",
    [mediaQueries.desktop]: {
      marginTop: "0"
    }
  },
  "& p": {
    fontFamily: "JWSansBook",
    fontSize: "19px",
    letterSpacing: "4px",
    textTransform: "uppercase",
    flexBasis: "100%",
    textAlign: "center",
    marginTop: "1.5em"
  }
};

const Spinner = ({ message }) => (
  <Div css={styles}>
    <span />
    <p>{message}</p>
  </Div>
);

Spinner.propTypes = {
  message: PropTypes.string
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/common/Spinner.js